<template>
	<div class="play_wrap">
		<!-- playwrap -->
		<div class="play_cont">
			<div class="play_title">{{play_title}}</div>
			<div class="play_video" v-if="bsid == 1">
				<div class="video">
					<video 
						:src="play_src"
						autoplay="autoplay"
						controls="controls"
						controlsList="nodownload"
						disablePictureInPicture></video>
				</div>
				<div class="videolist">
					<div class="list_title">
						<span :class="{select:select==1}" @click="select = 1">视频列表</span>
						<span :class="{select:select==2}"@click="select = 2">课程介绍</span>
					</div>
					<div class="video_cont">
						<div v-if="select==1">
							<div class="video_item" 
							:class="{select1:play_title == item.title}" 
							v-for="item in leftList"
							@click="changeVideo(item.v_url,item.title)">{{item.title}}</div>
						</div>
						<div class="jieshao" v-if="select == 2"  v-html="content"></div>
					</div>
				</div>
			</div>
			<div class="play_ppt play_ppt1" v-if="bsid == 2">
				<iframe id="iframe1"
				v-if="play_src.search('ppt') == -1"
				allowtransparency='yes'
				:src="play_src"></iframe>
				<iframe v-else
				:src="'https://view.officeapps.live.com/op/view.aspx?src='+play_src"
				style="margin-top: -90px;height: 788px;background: rgb(82,86,89);display: flex;align-items: center;"
				allowtransparency='yes'></iframe>
			</div>
			<div class="play_ppt" v-if="bsid == 3 || bsid == 4">
				<pdf :src="play_src"></pdf>
			</div>
		</div>
	</div>
</template>

<script>
	import pdf from 'vue-pdf'
	import { detail } from '@/axios'
	export default {
		data(){
			return{
				bsid:"",
				play_src:"",
				select:1,
				play_title:"",
				leftList:[],
				content:""
			}
		},
		components: {pdf},
		methods: {
			// 渲染数据
			data(){
				var that = this;
				that.bsid = that.$route.query.bsid;
				if(that.$route.query.type == 1){
					detail.politicsDetail({
						bsid:that.$route.query.bsid,
						id:that.$route.query.id
					}).then(res => {
						if(res.code == 200){
							that.play_src = res.data.v_url;
							that.play_title = res.data.title;
							that.content = res.data.content
							that.leftList.push({
								v_url:res.data.v_url,
								title:res.data.title
							})
						}
					})
				}else{
					detail.politicsDetail1({
						bsid:that.$route.query.bsid,
						id:that.$route.query.id
					}).then(res => {
						if(res.code == 200){
							that.play_src = res.data[0].v_url;
							that.play_title = res.data[0].title;
							that.content = res.data[0].content;
							that.leftList.push({
								v_url:res.data[0].v_url,
								title:res.data[0].title
							})
						}
					})
				}
			},
			// 切换
			changeVideo(v_url,title){
				var that = this;
				that.play_src = v_url;
				that.play_title = title;
			}
		},
		mounted(){
			var that = this;
			that.data();
			this.$emit("highLight",this.$route.query.index,"","","");
		}
	}
</script>

<style lang="scss">
	@import '@/common/index.scss'; 
	.play_wrap{
		width:$indexWidth;
		margin: auto;
		.play_cont{
			width: 100%;
			.play_title{
				font-size: 20px;
				font-weight: bold;
				color: #bb0000;
				line-height: 80px;
			}
			.play_video{
				width: 100%;
				height: 560px;
				background: rgb(39,40,34);
				display: flex;
				justify-content: space-between;
				.video{
					flex: 1;
					video{
						width: 100%;
						height: 100%;
						background: #000000;
						outline: none;
					}
				}
				.videolist{
					width: 300px;
					.list_title{
						color: #fff;
						font-size: 16px;
						line-height: 60px;
						display: flex;
						justify-content: space-between;
						align-items: center;
						box-sizing: border-box;
						span{
							cursor: pointer;
							width: 50%;
							border-bottom: 2px solid rgba($color: $indexColor4, $alpha: 0.2);
							text-align: center;
						}
						span:hover{
							border-bottom: 2px solid #bb0000;
							color: #bb0000;
						}
					}
					.select{
						border-bottom: 2px solid #bb0000 !important;
						color: #bb0000;
					}
					.video_cont{
						width: 100%;
						padding: 0 20px;
						box-sizing: border-box;
						height: 475px;
						overflow-y: scroll;
						overflow-x: hidden;
						.video_item{
							cursor: pointer;
							width: 100%;
							font-size: 16px;
							color: #fff;
							padding: 20px 0;
							line-height: 24px;
							letter-spacing: 1px;
							border-bottom:1px solid rgba($color: #fff, $alpha:0.2);
						}
						.video_item:hover{
							color: #bb0000;
						}
						.select1{
							color: #bb0000;
						}
						.jieshao{
							font-size: 16px;
							color: #fff;
							padding-top: 10px;
							line-height: 30px;
							letter-spacing: 2px;
						}
					}
					.video_cont::-webkit-scrollbar{
						width:0;
						height:12px;
					}
				}
			}
			.play_ppt{
				overflow: hidden;
				position: relative;
				width: 100%;
				height: 700px;
				overflow-y: scroll;
				box-sizing: border-box;
				border: 1px solid rgba($color: #000000, $alpha: 0.1);
				iframe{
					border: none;
					background: none;
					height: 100%;
					width: 100%;
				}
			}
			.play_ppt1{
				overflow: hidden;
			}
		}
	}
</style>
